import { useState, useEffect } from 'react'
// component
import { Search, Button } from 'carbon-components-react'
// import cogoToast from 'cogo-toast'
import RegistriesGrid from './RegistriesGrid'
import RegistryDetailModal from './RegistryDetailModal'
import ConfirmModal from '../../components/Modal/ConfirmModal'
// api
import {
  addRegistry,
  updateRegistry,
  deleteRegistry,
} from '../../api/registries'
import { toaster } from '../../helpers/toaster'

const useRegistriesGrid = ({
  isStudyDetail,
  studyRegistry,
  setStudyDetails,
  studyPgId,
  studyOrgStudyId,
  studyUid,
  refreshStudyData,
  studyListOptions,
} = {}) => {
  // const [registryList, setRegistryList] = useState([])
  const [registryData, setRegistryData] = useState(null)
  const [refreshData, setRefreshData] = useState(false)
  const [registryId, setRegistryId] = useState(null)
  const [registryLoading, setRegistryLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [searchGrid, setSearchGrid] = useState("")
  const [sort, setSort] = useState("")
  const [deleteItemId, setDeleteItemId] = useState(null)
  // modals
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openRegistryModal, setOpenRegistryModal] = useState(false)
  const [detailModalMode, setDetailModalMode] = useState(false)
  const onlyAttachment = localStorage.getItem('only_attachment')
  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px"
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search)
    }, 500)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search])

  /** EVENT HANDLERS */

  const openCreateRegistryModal = () => {
    setDetailModalMode("create")
    setRegistryData(null)
    setOpenRegistryModal(true)
  }

  const registryRowClicked = (data) => {
    setDetailModalMode("update")
    setRegistryId(data.id)
    setRegistryData(data)
    setOpenRegistryModal(true)
  }

  const showDeleteConfirm = (itemId) => {
    setOpenDeleteModal(true)
    setDeleteItemId(itemId)
  }

  const confirmSave = (regInfo) => {
    setRegistryLoading(true);
    return addRegistry(regInfo).then(res => {

      // for grid on study details page
      if (isStudyDetail && refreshStudyData && studyUid) {
        // Refresh the full study data from the server using UID
        refreshStudyData(studyUid).then(() => {
          toaster("Registry created successfully", "success")
          setRegistryLoading(false);
          setOpenRegistryModal(false)
        })
      } else if (isStudyDetail && studyRegistry && res.data) {
        // Fallback: update local state if no refresh function provided
        setStudyDetails({
          type: 'ADD_ITEM',
          itemType: 'study_registries',
          item: res.data,
        })
        toaster("Registry created successfully", "success")
        setRegistryLoading(false);
        setOpenRegistryModal(false)
      } else {
        // for registries list page
        setRefreshData(true)
        toaster("Registry created successfully", "success")
        setRegistryLoading(false);
        setOpenRegistryModal(false)
      }
      return res.data
    }).catch(error => {
      console.log('confirmSave error', error)
      toaster("Failed to create registry", "error")
      setRegistryLoading(false);
      setOpenRegistryModal(false)
    });

  }

  const confirmUpdate = (registryIndex, registryInfo) => {
    setRegistryLoading(true);
    return updateRegistry(registryIndex, registryInfo).then(res => {

      // for grid on study details page
      if (isStudyDetail && refreshStudyData && studyUid) {
        // Refresh the full study data from the server using UID
        refreshStudyData(studyUid).then(() => {
          toaster("Registry updated successfully", "success")
          setRegistryLoading(false);
          setOpenRegistryModal(false)
        })
      } else if (isStudyDetail && studyRegistry && res.data) {
        // Fallback: update local state if no refresh function provided
        setStudyDetails({
          type: 'UPDATE_ITEM',
          itemType: 'study_registries',
          item: res.data,
        })
        toaster("Registry updated successfully", "success")
        setRegistryLoading(false);
        setOpenRegistryModal(false)
      } else {
        // for registries list page
        setRefreshData(true)
        toaster("Registry updated successfully", "success")
        setRegistryLoading(false);
        setOpenRegistryModal(false)
      }
      return res.data
    }).catch(error => {
      toaster("Failed to update registry", "error")
      setRegistryLoading(false);
      setOpenRegistryModal(false)
    });

  }

  const confirmDelete = () => {
    setRegistryLoading(true)
    deleteRegistry(deleteItemId).then(res => {
      // for grid on study details page
      if (isStudyDetail && refreshStudyData && studyUid) {
        // Refresh the full study data from the server using UID
        refreshStudyData(studyUid).then(() => {
          toaster("Registry deleted successfully", "success")
          setRegistryLoading(false)
          setOpenDeleteModal(false)
        })
      } else if (studyRegistry && setStudyDetails) {
        // Fallback: update local state if no refresh function provided
        setStudyDetails({
          type: 'DELETE_ITEM',
          itemType: 'study_registries',
          id: deleteItemId,
        })
        toaster("Registry deleted successfully", "success")
        setRegistryLoading(false)
        setOpenDeleteModal(false)
      } else {
        // for registries list page
        setRefreshData(true)
        toaster("Registry deleted successfully", "success")
        setRegistryLoading(false)
        setOpenDeleteModal(false)
      }
    })
  }

  /** COMPONENTS */


  const addRegistryButton = () => {
    return <Button
      kind="primary"
      onClick={() => openCreateRegistryModal()}
      style={addBtnStyle}
      disabled={onlyAttachment === "true"}
    >Add Registry
    </Button>
  }

  const registrySearch = () => {
    return <div style={{ width: "300px" }}>
      <Search
        size="sm"
        value={search}
        labelText="search"
        onChange={e => setSearch(e.target.value)}
        placeHolderText="Search using any data value" />
    </div>
  }


  const registriesGrid = () => {
    return <>
      <RegistriesGrid
        registriesList={studyRegistry}
        onRowClicked={registryRowClicked}
        search={searchGrid}
        onDeleteClicked={showDeleteConfirm}
        setRefresh={setRefreshData}
        refresh={refreshData}
        sort={sort}
        setSort={setSort}
        isStudyDetail={isStudyDetail}
      />
      <RegistryDetailModal
        mode={detailModalMode}
        registryIndex={registryId}
        open={openRegistryModal}
        registryData={registryData}
        onClose={() => setOpenRegistryModal(false)}
        confirmSave={confirmSave}
        confirmUpdate={confirmUpdate}
        setRegistryLoading={setRegistryLoading}
        isStudyDetail={isStudyDetail}
        studyOrgStudyId={isStudyDetail ? studyOrgStudyId : null}
        studyPgId={isStudyDetail ? studyPgId : null}
        studyListOptions={studyListOptions}
      />
      <ConfirmModal
        title="Confirmation"
        content="Are you sure you want to delete this registry?"
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        onConfirm={() => confirmDelete()}
      />
    </>
  }

  return {
    addRegistryButton,
    registrySearch,
    registriesGrid,
    registryLoading,
    setRegistryLoading,
  }
}

export default useRegistriesGrid